export default "__VITE_ASSET__60e67e1e__"